export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  imageSeq: string;
  imageWidth: number;
  imageHeight: number;
  imageQuery: string;
  hotValue: number;
  author: string;
  authorAvatar: string;
  publishDate: string;
  tags: string[];
  content: string;
}

export const hotArticles: Article[] = [
  {
    id: 'article-1',
    title: '某千万粉丝网红深夜道歉，承认涉及多项不实炒作',
    excerpt: '在一段长达15分钟的视频中，该网红泣不成声地承认了此前被爆出的多项炒作行为，涉及虚假人设、数据造假等多个方面。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Emotional%20Chinese%20influencer%20apologizing%20in%20video%2C%20dramatic%20lighting%2C%20tearful%20expression%2C%20dark%20background%20with%20warm%20spotlight%2C%20cinematic%20portrait%20photography%2C%20high%20contrast%2C%20moody%20atmosphere%2C%20professional%20studio%20lighting&width=800&height=600&seq=hot-article-01&orientation=landscape',
    imageSeq: 'hot-article-01',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Emotional Chinese influencer apologizing in video, dramatic lighting, tearful expression, dark background with warm spotlight, cinematic portrait photography, high contrast, moody atmosphere, professional studio lighting',
    hotValue: 98234,
    author: '吃瓜小编',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20news%20editor%20portrait%2C%20simple%20warm%20background%2C%20friendly%20expression%2C%20minimalist%20style&width=100&height=100&seq=avatar-editor-01&orientation=squarish',
    publishDate: '2026-07-07',
    tags: ['网红塌房', '道歉声明', '炒作内幕'],
    content: '详细内容待补充...',
  },
  {
    id: 'article-2',
    title: '娱乐圈又爆大瓜！某顶流男星被拍到深夜密会',
    excerpt: '据知情人士透露，该男星与神秘女子在某高档酒店共度一夜，引发粉丝集体脱粉，工作室至今未回应。',
    category: '娱乐吃瓜',
    categorySlug: 'yule-chigua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20shot%20of%20luxury%20hotel%20entrance%2C%20dramatic%20moody%20lighting%2C%20blurred%20figures%2C%20urban%20night%20scene%2C%20cinematic%20photography%2C%20mysterious%20atmosphere&width=800&height=600&seq=hot-article-02&orientation=landscape',
    imageSeq: 'hot-article-02',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Paparazzi style night shot of luxury hotel entrance, dramatic moody lighting, blurred figures, urban night scene, cinematic photography, mysterious atmosphere',
    hotValue: 87521,
    author: '八卦猎人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20journalist%20portrait%2C%20simple%20warm%20background%2C%20professional%20style%2C%20minimalist&width=100&height=100&seq=avatar-editor-02&orientation=squarish',
    publishDate: '2026-07-06',
    tags: ['娱乐吃瓜', '顶流密会', '深夜爆料'],
    content: '详细内容待补充...',
  },
  {
    id: 'article-3',
    title: '知名带货主播被曝虚假宣传，消费者集体维权',
    excerpt: '该主播在直播中宣称产品具有神奇功效，经检测后发现实际成分与宣传严重不符，已有上百名消费者联名投诉。',
    category: '黑料大瓜',
    categorySlug: 'heiliao-dagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20livestreamer%20selling%20products%20under%20spotlight%2C%20dramatic%20contrast%2C%20suspicious%20atmosphere%2C%20studio%20setting%20with%20products%20on%20display%2C%20cinematic%20lighting&width=800&height=600&seq=hot-article-03&orientation=landscape',
    imageSeq: 'hot-article-03',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Chinese livestreamer selling products under spotlight, dramatic contrast, suspicious atmosphere, studio setting with products on display, cinematic lighting',
    hotValue: 76298,
    author: '消费观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20consumer%20rights%20reporter%20portrait%2C%20simple%20warm%20background%2C%20minimalist%20style&width=100&height=100&seq=avatar-editor-03&orientation=squarish',
    publishDate: '2026-07-05',
    tags: ['黑料大瓜', '虚假宣传', '消费者维权'],
    content: '详细内容待补充...',
  },
  {
    id: 'article-4',
    title: '选秀冠军私生活混乱？前女友曝光大量聊天记录',
    excerpt: '一段疑似某选秀节目冠军与前女友的聊天记录在网上疯传，涉及多段暧昧关系及不当言论。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20chat%20messages%20in%20Chinese%2C%20dark%20moody%20background%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20digital%20privacy%20concept&width=800&height=600&seq=hot-article-04&orientation=landscape',
    imageSeq: 'hot-article-04',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Smartphone screen showing chat messages in Chinese, dark moody background, dramatic lighting, mysterious atmosphere, digital privacy concept',
    hotValue: 65430,
    author: '深夜吃瓜人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20gossip%20blogger%20portrait%2C%20simple%20warm%20background%2C%20minimalist%20style&width=100&height=100&seq=avatar-editor-04&orientation=squarish',
    publishDate: '2026-07-04',
    tags: ['网红塌房', '聊天记录', '选秀冠军'],
    content: '详细内容待补充...',
  },
  {
    id: 'article-5',
    title: '知名综艺节目录制现场发生意外，嘉宾当场翻脸',
    excerpt: '据现场观众爆料，两位常驻嘉宾在录制过程中因观点不合发生激烈争吵，节目组紧急暂停录制。',
    category: '娱乐吃瓜',
    categorySlug: 'yule-chigua',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20recording%20set%20with%20dramatic%20tension%2C%20two%20people%20arguing%2C%20production%20crew%20in%20background%2C%20cinematic%20lighting%2C%20intense%20atmosphere&width=800&height=600&seq=hot-article-05&orientation=landscape',
    imageSeq: 'hot-article-05',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'TV studio recording set with dramatic tension, two people arguing, production crew in background, cinematic lighting, intense atmosphere',
    hotValue: 58421,
    author: '节目观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20critic%20portrait%2C%20simple%20warm%20background%2C%20minimalist%20style&width=100&height=100&seq=avatar-editor-05&orientation=squarish',
    publishDate: '2026-07-03',
    tags: ['娱乐吃瓜', '综艺节目', '嘉宾冲突'],
    content: '详细内容待补充...',
  },
];

export const dailyContestArticles: Article[] = [
  {
    id: 'daily-1',
    title: '网红圈年度最大翻车：从神坛跌落的24小时全纪录',
    excerpt: '一场直播引发的连锁反应，让这位拥有三千万粉丝的顶流网红在一天之内经历了从巅峰到谷底的过山车。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20downfall%20of%20social%20media%20star%2C%20artistic%20concept%2C%20falling%20crown%20on%20dark%20background%2C%20cinematic%20lighting%2C%20magazine%20editorial%20style%2C%20high%20contrast%2C%20warm%20golden%20accents&width=600&height=800&seq=daily-contest-01&orientation=portrait',
    imageSeq: 'daily-contest-01',
    imageWidth: 600,
    imageHeight: 800,
    imageQuery: 'Dramatic downfall of social media star, artistic concept, falling crown on dark background, cinematic lighting, magazine editorial style, high contrast, warm golden accents',
    hotValue: 99876,
    author: '吃瓜前线',
    authorAvatar: '',
    publishDate: '2026-07-07',
    tags: ['网红翻车', '年度大盘点'],
    content: '',
  },
  {
    id: 'daily-2',
    title: '娱乐圈隐婚生子曝光，多位明星家庭秘密浮出水面',
    excerpt: '一场意外的亲子活动照片泄露，揭开了娱乐圈多位明星多年来苦心经营的单身人设。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20family%20portrait%20concept%2C%20blurred%20faces%2C%20warm%20ambient%20lighting%2C%20artistic%20photography%2C%20magazine%20editorial%20style%2C%20soft%20focus%2C%20intimate%20atmosphere&width=600&height=800&seq=daily-contest-02&orientation=portrait',
    imageSeq: 'daily-contest-02',
    imageWidth: 600,
    imageHeight: 800,
    imageQuery: 'Mysterious family portrait concept, blurred faces, warm ambient lighting, artistic photography, magazine editorial style, soft focus, intimate atmosphere',
    hotValue: 87654,
    author: '娱记老王',
    authorAvatar: '',
    publishDate: '2026-07-06',
    tags: ['隐婚生子', '明星家庭'],
    content: '',
  },
  {
    id: 'daily-3',
    title: '顶级流量数据造假产业链揭秘：从刷量到控评',
    excerpt: '深度调查揭露隐藏在光鲜数据背后的灰色产业链，涉及多家头部MCN机构与数据公司。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20data%20manipulation%20concept%2C%20glowing%20numbers%20in%20darkness%2C%20hacker%20aesthetic%2C%20cyberpunk%20style%2C%20magazine%20editorial%20photography%2C%20dramatic%20lighting&width=600&height=800&seq=daily-contest-03&orientation=portrait',
    imageSeq: 'daily-contest-03',
    imageWidth: 600,
    imageHeight: 800,
    imageQuery: 'Digital data manipulation concept, glowing numbers in darkness, hacker aesthetic, cyberpunk style, magazine editorial photography, dramatic lighting',
    hotValue: 76543,
    author: '数据猎人',
    authorAvatar: '',
    publishDate: '2026-07-05',
    tags: ['数据造假', '产业链曝光'],
    content: '',
  },
];

export const gossipWallItems = [
  {
    id: 'wall-1',
    author: '匿名网友A',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20profile%20photo%2C%20dark%20silhouette%2C%20mysterious%20style%2C%20simple%20warm%20background%2C%20minimalist&width=120&height=120&seq=gossip-avatar-01&orientation=squarish',
    rating: 4.8,
    content: '这个网站真的太牛了！每天都能在这里看到最新的瓜，比微博还快。上次那个网红塌房事件，我在这里看到的时候微博还没有任何消息，绝对是吃瓜第一线！',
    date: '2026-07-07',
  },
  {
    id: 'wall-2',
    author: '资深吃瓜群众',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20professional%20portrait%2C%20simple%20warm%20background%2C%20friendly%20expression%2C%20minimalist%20style&width=120&height=120&seq=gossip-avatar-02&orientation=squarish',
    rating: 4.9,
    content: '关注吃瓜网已经半年多了，每次娱乐圈有大事件都是第一时间更新。推荐给了身边所有喜欢八卦的朋友，没有一个说不好的。编辑们辛苦了！',
    date: '2026-07-06',
  },
  {
    id: 'wall-3',
    author: '夜猫子吃瓜',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20at%20night%2C%20simple%20warm%20background%2C%20minimalist%20style%2C%20mysterious%20vibe&width=120&height=120&seq=gossip-avatar-03&orientation=squarish',
    rating: 4.7,
    content: '作为一个夜猫子，我最喜欢凌晨刷新吃瓜网。那些半夜爆出来的猛料真的一个比一个劲爆。APP也很好用，推送非常及时，从来没漏过任何一个大瓜！',
    date: '2026-07-05',
  },
];

export const categories = [
  { name: '网红塌房', slug: 'wanghong-tafang', icon: 'ri-alert-fill', count: 128 },
  { name: '娱乐吃瓜', slug: 'yule-chigua', icon: 'ri-movie-2-line', count: 256 },
  { name: '黑料大瓜', slug: 'heiliao-dagua', icon: 'ri-spy-line', count: 189 },
  { name: '每日大赛', slug: 'daily-contest', icon: 'ri-fire-line', count: 97 },
  { name: '实时追踪', slug: 'shishi-zhuizong', icon: 'ri-radar-line', count: 143 },
  { name: '八卦爆料', slug: 'bagua-baoliao', icon: 'ri-chat-smile-2-line', count: 312 },
];